import {FETCH_CONSULT_PACKAGES} from '../constants/consult-package';

export function fetchConsultPackages() {
  return ({
    type: FETCH_CONSULT_PACKAGES,
    api: true,
    payload: {
      method: 'GET',
      url: '/packages/packages'
    }
  });
}
